'use client';

import React, { useState, useEffect } from 'react';
import { Cookie, X, Settings, Check } from 'lucide-react';
import CookieSettingsModal from './CookieSettingsModal';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('pg-cookie-consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('pg-cookie-consent', JSON.stringify({
      necessary: true,
      analytics: true,
      marketing: true,
      timestamp: new Date()?.toISOString(),
    }));
    setVisible(false);
  };

  const acceptNecessary = () => {
    localStorage.setItem('pg-cookie-consent', JSON.stringify({
      necessary: true,
      analytics: false,
      marketing: false,
      timestamp: new Date()?.toISOString(),
    }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <>
      <div className="fixed bottom-0 left-0 right-0 z-50 p-4 cookie-banner">
        <div
          className="max-w-screen-lg mx-auto rounded-2xl p-5 shadow-2xl"
          style={{
            background: 'var(--card)',
            border: '1px solid var(--border)',
            boxShadow: '0 -4px 40px rgba(124,58,237,0.2)',
          }}
        >
          <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
            <div className="flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'rgba(124,58,237,0.15)' }}>
              <Cookie size={20} style={{ color: 'var(--primary)' }} />
            </div>

            <div className="flex-1 min-w-0">
              <p className="font-semibold text-sm mb-1">Wir verwenden Cookies 🍪</p>
              <p className="text-xs leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
                Wir nutzen Cookies für ein besseres Spielerlebnis, Analysen und personalisierte Inhalte.
                Deine Einstellungen kannst du jederzeit im Footer ändern.{' '}
                <a href="/impressum#datenschutz" className="underline hover:opacity-80" style={{ color: 'var(--neon-violet)' }}>
                  Datenschutzerklärung
                </a>
              </p>
            </div>

            <div className="flex flex-wrap gap-2 flex-shrink-0">
              <button
                onClick={() => { setSettingsOpen(true); }}
                className="flex items-center gap-1 px-3 py-2 rounded-lg text-xs font-medium transition-all hover:bg-white/5"
                style={{ color: 'var(--muted-foreground)', border: '1px solid var(--border)' }}
              >
                <Settings size={12} />
                Einstellungen
              </button>
              <button
                onClick={acceptNecessary}
                className="flex items-center gap-1 px-3 py-2 rounded-lg text-xs font-medium transition-all hover:bg-white/5"
                style={{ color: 'var(--muted-foreground)', border: '1px solid var(--border)' }}
              >
                Nur notwendige
              </button>
              <button
                onClick={acceptAll}
                className="btn-primary flex items-center gap-1 px-4 py-2 text-xs"
              >
                <Check size={12} />
                Alle akzeptieren
              </button>
            </div>

            <button
              onClick={() => setVisible(false)}
              className="absolute top-3 right-3 sm:relative sm:top-auto sm:right-auto p-1 rounded-lg hover:bg-white/5 transition-colors"
              style={{ color: 'var(--muted-foreground)' }}
              aria-label="Schließen"
            >
              <X size={16} />
            </button>
          </div>
        </div>
      </div>

      <CookieSettingsModal
        open={settingsOpen}
        onClose={() => {
          setSettingsOpen(false);
          setVisible(false);
        }}
      />
    </>
  );
}